define('app-Agents/modules/passwordStrength/module',["./settings"], function (settings) {
    var container = $(settings.container);

    if (container.length === 0) {
        return null;
    }

    return {
        minCharacterRegex: new RegExp("^(?=.{" + settings.password.minCharacters + ",})"),
        lowercaseUppercaseRegex: new RegExp("^(?=.*[a-z])(?=.*[A-Z])"),
        numberRegex: new RegExp("^(?=.*[0-9])"),
        specialCharacterRegex: new RegExp("^(?=.*[^a-zA-Z0-9 ])"),

        testPassword: function (password) {
            var failedValidation = false;
            var minCharacterTest = this.minCharacterRegex.test(password);
            var lowercaseUppercaseTest = !settings.password.mustContainLowercaseUppercase || this.lowercaseUppercaseRegex.test(password);
            var numberTest = !settings.password.mustContainNumber || this.numberRegex.test(password);
            var specialCharacterTest = !settings.password.mustContainSpecialCharacter || this.specialCharacterRegex.test(password);
            var matchingTest = password !== "" && $(settings.confirmPasswordField).val() === password;

            if (!minCharacterTest || !lowercaseUppercaseTest || !numberTest || !specialCharacterTest || !matchingTest) {
                failedValidation = true;
            }

            return {
                "minCharacters": minCharacterTest,
                "lowercaseUppercaseLetter": lowercaseUppercaseTest,
                "number": numberTest,
                "specialCharacter": specialCharacterTest,
                "matching": matchingTest,
                "failedValidation": failedValidation
            }
        },

        initialise: function (globalSettings) {
            var thisModule = this;
            var containerRow = container.closest(".row");
            var passwordField = containerRow.find(settings.passwordField);

            passwordField.on("keyup", function () {
                var passwordTests = thisModule.testPassword($(this).val());

                container.find(settings.minCharacterLi)
                    .removeClass("pass fail")
                    .addClass(passwordTests.minCharacters ? "pass" : "fail");

                container.find(settings.lowercaseUppercaseLi)
                    .removeClass("pass fail")
                    .addClass(passwordTests.lowercaseUppercaseLetter ? "pass" : "fail");

                container.find(settings.numberLi)
                    .removeClass("pass fail")
                    .addClass(passwordTests.number ? "pass" : "fail");

                container.find(settings.specialCharacterLi)
                    .removeClass("pass fail")
                    .addClass(passwordTests.specialCharacter ? "pass" : "fail");

                container.find(settings.matchingLi)
                    .removeClass("pass fail")
                    .addClass(passwordTests.matching ? "pass" : "fail");

                if (passwordTests.failedValidation) {
                    // stop form submission or whatever
                }
            });

            // trigger validation from confirm password field
            containerRow.find(settings.confirmPasswordField).on("keyup", function () {
                passwordField.trigger("keyup");
            });
        }
    }
});
